module.exports = __webpack_public_path__ + "64c4a99795548c528286eb0bde64dd86.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/logos/brand-logo-amplifybuzz.png
// module id = 627
// module chunks = 0